import { MouseEventHandler } from "react";

interface Props {
	icon?: string;
	text: string;
	className?: string;
	img?: string;
	onClick?: MouseEventHandler<HTMLButtonElement>;
	disabled?: boolean;
}

const VerificaIdentitaCard: React.FC<Props> = (props) => {
	const { icon, text, className, img, onClick, disabled } = props;

	return (
		<button
			className={"verifica-identita-card border " + className}
			onClick={onClick}
			disabled={disabled}
		>
			{icon && <i className={icon}></i>}
			{img && <img src={img} />}
			<p>{text}</p>
		</button>
	);
};

export default VerificaIdentitaCard;
